module.exports = __webpack_public_path__ + "static/media/windowcleaning.06bea212.png";